module.exports = __webpack_public_path__ + "img/kharkiv.de5c2177.png";